import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
function initCarousel(blockEl) {
  console.log('test');
  const swiperEl = blockEl.querySelector('.swiper');
  if (!swiperEl) return;

  // anty-duplikacja (np. przy ajaxach lub ponownym renderze)
  if (swiperEl.dataset.inited === '1') return;
  swiperEl.dataset.inited = '1';

  const showArrows = blockEl.dataset.showArrows === '1';
  const showPagination = blockEl.dataset.showPagination === '1';
  const spaceBetween = Number(blockEl.dataset.spaceBetween || 16);
  const spvMobile = Number(blockEl.dataset.spvMobile || 1.15);
  const spvDesktop = Number(blockEl.dataset.spvDesktop || 4);

  const nextEl = swiperEl.querySelector('.swiper-button-next');
  const prevEl = swiperEl.querySelector('.swiper-button-prev');
  const pagEl = swiperEl.querySelector('.swiper-pagination');

  const canNav = !!nextEl && !!prevEl;
  const canPag = !!pagEl;

  // eslint-disable-next-line no-new
  new Swiper(swiperEl, {
    modules: [Navigation, Pagination],
    slidesPerView: spvMobile,
    spaceBetween,
    watchOverflow: true,
    grabCursor: true,
    breakpoints: {
      782: {
        slidesPerView: spvDesktop,
        spaceBetween,
      },
    },
    navigation: {
      enabled: !!showArrows && canNav,
      nextEl,
      prevEl,
    },
    pagination: {
      enabled: !!showPagination && canPag,
      el: pagEl,
      clickable: true,
    },
  });
}

function initAll() {
  document.querySelectorAll('.wp-block-custom-carousel-boxes.cb-swiper').forEach(initCarousel);
}

document.addEventListener('DOMContentLoaded', initAll);
